<template lang="pug">
el-dialog(v-dialog-drag, :title="title", top="50px", width="1000px", :visible.sync="show", :close-on-click-modal="false", @close="closeHandler")
  template(#default)
    .content
      el-form(:model="authData", label-width="120px", :rules="rules", ref="ruleForm", label-position="left" size='small')
        el-form-item(label="名称", prop="title")
          el-input(v-model="authData.title")
        el-form-item(label="描述", prop="desc")
          el-input(v-model="authData.desc", type="textarea")
        el-form-item(label="权限组成员", prop="authGroupListType")
          el-radio-group(v-model="authData.authGroupListType")
            el-radio(v-for="(it, index) in subjectOptions", :key="index", :label="it.subjectCode") {{ it.subjectName }}
            el-button(type="text", @click="openSubject") 设置成员范围
          div(v-if="authData.subjectLabel && authData.subjectLabel.length > 0")
            .tag-block(v-for="(it, index2) in authData.subjectLabel", :key="index2")
              .name {{ it.subjectName }}：
              .tag-con
                el-tag.tag(v-for="(tag, index) in it.subjectValues", :key="index", size="mini", @close="deleteValue(it.subjectValues, index)", closable) {{ tag.label }}
        el-form-item(label="数据范围", prop="dataRange")
          el-radio-group(v-model="authData.strategyType")
            el-radio(:label="1") 标准（默认）
            el-radio(:label="2") 自定义SQL（限新增操作）
            el-radio(:label="3") 自定义SQL（除新增操作外）
          el-checkbox-group(v-if="authData.strategyType === 1" v-model="authData.dataRange")
            el-checkbox(v-for="it in dataRangeOptions", :label="it.filterType", :disabled="it.disabled", :key="it.id") {{ it.filterName }}
          div(v-else) AND EXISTS （
            codemirror(ref="jsonEditor" v-model="authData.sqlFragments" class="codemirror" :options="cmOptions")
            div ）
            .desc 说明：
            .desc 1.只允许填写 select 语句，这个语句将作为 exists 子句参与查询，用于限定人员和数据范围
            .desc 2.请按 mybatis 的语法来编写 SQL 脚本
            .desc 3.只能包含清单中的可用变量，如 ${_T_}
              el-popover(placement="top-start" title="" width="350" trigger="click")
                div() 可用的变量清单：
                  div(class="flex")
                    div ${_T_}
                    div 主名的别名
                  div(class="flex")
                    div \#{p.__C_USER_ID__}
                    div 当前用户ID
                  div(class="flex")
                    div \#{p.__C_DEPT_ID__}
                    div 当前用户所在的部门ID（主部门）
                  div(class="flex")
                    div \#{p.__C_BRANCH_ID_}
                    div 当前分支机构ID
                  div(class="flex")
                    div \#{p.__ENTERPRISE_ID__}
                    div 当前企业ID
                el-button(type="text" slot="reference") 【可用变量清单】

        el-form-item(label="操作权限", prop="operationPermission")
          el-checkbox-group(v-model="authData.operationPermission")
            el-checkbox(v-for="it in showOperateAuthOptions", :label="it.actionCode", :key="it.actionId" :disabled="it.actionCode === 'A' && authData.strategyType === 2") {{ it.actionName }}
            operateAuthAddDialog(:resource-id="nodeData.groupId", @select="operationChange")
        el-form-item(label="字段设置", v-if="false")
          el-button(type="text", @click="openField") 设置字段
    authGroupFieldMaintain(ref="fieldMaintain")
  template(#footer)
    div
      .right
        el-button(size="small", @click="close") 取消
        el-button(type="primary", size="small", @click="saveHandler") 保存
</template>

<script>
import authGroupFieldMaintain from "./authGroupFieldMaintain.vue";
import strategyAuthService from "@/CommonDP/service/strategyAuth-service";
import operateAuthMaintain from "./operateAuthMaintain.vue";
import operateAuthAddDialog from "./operateAuthAddDialog.vue";
import { CODE_ID_MAP, openMember } from "@/CommonDP/components/chooseMember/leftCom";

import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/mode/sql/sql.js";
// 替换主题这里需修改名称
import "codemirror/theme/idea.css";
import "codemirror/theme/xq-light.css";
import "codemirror/mode/sql/sql.js";
// 加提示的引用
import "codemirror/addon/hint/show-hint.css";
import "codemirror/addon/hint/sql-hint";
import "codemirror/addon/hint/show-hint";
const COPY_TYPE = "copy";
const TITLE = {
  ADD: "新增策略",
  EDIT: "编辑策略",
  COPY: "复制策略"
};
const MODE = {
  ADD: "add",
  EDIT: "edit",
  COPY: "copy"
};
const SUBJECT_DEFAULT = "AllUsers";
const SUBJECT_CUSTOM = "Custom";
const ALL_DATA = "all";
export default {
  name: "AuthGroupMaintain",
  components: {
    authGroupFieldMaintain,
    operateAuthMaintain,
    operateAuthAddDialog,
    codemirror
  },
  props: {},
  data() {
    return {
      show: false,
      title: "",
      MODE,
      mode: "", // 组件模式，
      authData: this.createAuthData(),
      nodeData: {},
      subjectOptions: [],
      dataRangeOptions: [],
      operateAuthOptions: [],
      rules: {
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
        operationPermission: [{ required: true, message: "请选择操作权限", trigger: "blur" }],
        dataRange: [{ required: true, message: "请选择数据权限", trigger: "blur", validator: this.validateDataRange }],
        authGroupListType: [{ required: true, message: "请选择权限组成员", trigger: "blur" }]
      },
      cmOptions: {
        tabSize: 4,
        mode: "text/x-sql",
        theme: "xq-light",
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        matchBrackets: true, // 括号匹配
        lineWrapping: true,
        // 加提示
        hintOptions: {
          completeSingle: false
        }
      }
    };
  },
  computed: {
    showOperateAuthOptions() {
      if (this.authData.strategyType === 2) {
        return this.operateAuthOptions.filter((item) => ["A", "I"].includes(item.actionCode));
      } else if (this.authData.strategyType === 3) {
        return this.operateAuthOptions.filter((item) => !["A", "I"].includes(item.actionCode));
      }
      return this.operateAuthOptions;
    }
  },
  watch: {
    "authData.dataRange": {
      handler(val) {
        // 全部数据选中，其他数据权限禁用；其他权限数据选中，全部禁用
        if (this.authData.dataRange.includes(ALL_DATA)) {
          this.dataRangeOptions.forEach((it) => {
            if (it.filterType === ALL_DATA) {
              it.disabled = false;
            } else {
              it.disabled = true;
            }
          });
        } else {
          this.dataRangeOptions.forEach((it) => {
            if (it.filterType === ALL_DATA) {
              if (this.authData.dataRange.length > 0) {
                it.disabled = true;
              } else {
                it.disabled = false;
              }
            } else {
              it.disabled = false;
            }
          });
        }
      },
      deep: true
    },
    "authData.strategyType": {
      handler(val) {
        if (val === 3) {
          this.authData.operationPermission = this.authData.operationPermission.filter((item) => !["A", "I"].includes(item));
        } else if (val === 2) {
          this.authData.operationPermission = ["A"];
        }
      }
    }
  },
  created() {},
  methods: {
    open(nodeData, editData = null, type) {
      // console.log(nodeData);
      // console.log(editData);
      this.openType = type;
      this.show = true;
      this.nodeData = nodeData;
      if (editData) {
        if (this.openType === COPY_TYPE) {
          this.mode = this.MODE.COPY;
          this.title = TITLE.COPY;
        } else {
          this.mode = this.MODE.EDIT;
          this.title = TITLE.EDIT;
        }
        this.setAuthDataFormBody(editData);
      } else {
        this.mode = this.MODE.ADD;
        this.title = TITLE.ADD;
      }
      this.$forceUpdate();
      this.initDict();
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    close() {
      this.show = false;
      this.closeHandler();
    },
    createAuthData() {
      return {
        title: "",
        strategyId: "",
        desc: "",
        authGroupListType: SUBJECT_DEFAULT,
        sqlFragments: "",
        strategyType: 1,
        dataRange: [],
        operationPermission: [],
        fieldPermission: [],
        subjects: [],
        subjectLabel: []
      };
    },
    operationChange(data) {
      this.operateAuthOptions = data;
    },
    async initDict() {
      const params = {
        resourceId: this.nodeData.groupId
      };
      if (this.authData.strategyId) {
        params.strategyId = this.authData.strategyId;
      }
      const { data } = await strategyAuthService.getStrategyCreateDictList(params);
      console.log(data);
      this.operateAuthOptions = data.actionList;
      this.dataRangeOptions = data.filterList;
      this.subjectOptions = data.subjectList;

      this.authData.dataRange = data.filterList.filter((it) => it.checked).map((it) => it.filterType);
      this.authData.operationPermission = data.actionList.filter((it) => it.checked).map((it) => it.actionCode);
      //  角色
      const select = data.subjectList.find((it) => it.checked);
      this.authData.authGroupListType = select?.subjectCode || SUBJECT_DEFAULT;
      if (this.authData.authGroupListType === SUBJECT_CUSTOM) {
        this.authData.subjectLabel = this.getSelectSublist(data.subjectList[1].childList);
      }
    },
    getSelectSublist(arr) {
      const res = [];
      arr.forEach((it) => {
        if (it.checked) {
          res.push(it);
        }
        if (it.subjectValues) {
          it.subjectValues = it.subjectValues.map((v) => {
            return {
              label: v.value,
              value: v.id
            };
          });
        }
      });
      return res;
    },
    resetData() {
      this.authData = this.createAuthData();
    },
    setAuthDataFormBody(body) {
      console.log("body", body);
      if (body.strategyId) {
        this.authData.strategyId = body.strategyId;
      } else {
        this.authData.strategyId = "";
      }
      this.authData.title = body.strategyName;
      this.authData.desc = body.remark;
      this.authData.sqlFragments = body.sqlFragments || "";
      this.authData.strategyType = body.strategyType;
    },
    getBodyFromAuthData() {
      const authData = this.authData;
      const nodeData = this.nodeData;
      const body = {
        resourceId: nodeData.groupId,
        strategyName: authData.title,
        strategyType: authData.strategyType,
        sqlFragments: authData.sqlFragments,
        remark: authData.desc,
        filters: authData.dataRange,
        actions: [],
        fields: []
      };

      if (authData.operationPermission && authData.operationPermission.length > 0) {
        if (this.operateAuthOptions.length > 0) {
          this.operateAuthOptions.forEach((op) => {
            if (authData.operationPermission.includes(op.actionCode)) {
              body.actions.push({
                actionId: op.actionId,
                actionCode: op.actionCode
              });
            }
          });
        }
      }

      // 角色
      if (authData.authGroupListType === SUBJECT_DEFAULT) {
        body.subjects = [
          {
            subjectCode: SUBJECT_DEFAULT,
            values: []
          }
        ];
      } else {
        body.subjects = authData.subjectLabel.map((it) => {
          return {
            subjectCode: it.subjectCode,
            values: it.subjectValues.map((it) => it.value)
          };
        });
      }
      if (authData.strategyId) {
        body.strategyId = authData.strategyId;
      }
      if (this.mode === this.MODE.COPY) {
        delete body.strategyId;
      }
      return body;
    },
    async postData() {
      const postFunction = this.getPostFunction();
      const body = this.getBodyFromAuthData();
      console.log("body", body);
      const res = await postFunction(body);
      console.log("res", res);
      this.$success("保存成功!");
      this.$emit("success");
      this.close();
    },
    getPostFunction() {
      if (this.mode === this.MODE.ADD) {
        return strategyAuthService.strategyCreate;
      } else if (this.mode === this.MODE.EDIT) {
        return strategyAuthService.strategyAuthUpdate;
      } else if (this.mode === this.MODE.COPY) {
        return strategyAuthService.strategyCreate;
      }
    },
    subjectSelected(s1, s2) {
      this.authData.subjectLabel = s1;
    },
    closeHandler() {
      this.resetData();
    },
    async openSubject() {
      const raws = this.authData.subjectLabel;
      const _raws = [];
      for (const { subjectValues, subjectCode } of raws) {
        const { id: idKey, name: labelKey } = CODE_ID_MAP[subjectCode] || {};
        if (!idKey || !subjectValues) continue;
        for (const { label, value } of subjectValues) {
          const item = {
            [idKey]: value,
            [labelKey]: label,
            id: value,
            name: label,
            nodeId: value,
            selectName: label,
            selectCode: subjectCode
          };
          _raws.push(item);
        }
      }
      const codePri = ["SystemRole", "SpecRole", "PrjRole", "Dept", "User"];
      const _list = await openMember({
        codePri,
        filterOneself: false,
        usersList: _raws
      });
      const list = [];
      for (const subjectCode of codePri) {
        const { id: idKey, name: nameKey, label } = CODE_ID_MAP[subjectCode] || {};
        if (!idKey) continue;
        const subjectValues = _list.filter(({ selectCode }) => selectCode === subjectCode).map(({ [idKey]: value, [nameKey]: label }) => ({ label, value }));
        const values = subjectValues.map(({ id }) => id);
        if (!subjectValues?.length) continue;
        const item = {
          checked: true,
          subjectCode,
          subjectName: label,
          subjectValues,
          values
        };
        list.push(item);
      }
      this.authData.authGroupListType = SUBJECT_CUSTOM;
      this.authData.subjectLabel = list;
    },
    deleteValue(array, index) {
      array.splice(index, 1);
    },
    openField() {
      this.$refs.fieldMaintain.open();
    },
    saveHandler() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.postData();
        } else {
          console.log("校验未通过");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.clearValidate();
    },
    validateDataRange(rule, value, callback) {
      // 自定义校验逻辑，例如检查用户名是否符合要求
      if (this.authData.strategyType === 1 && !this.authData.dataRange.length) {
        callback(new Error("请选择数据权限"));
      } else {
        callback();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.icon-button {
  font-size: 20px;
  vertical-align: top;
}

.ml-20 {
  margin-left: 20px;
}

.content {
  padding: 16px;
  max-height: 80vh;
  min-height: 60vh;
  overflow: auto;

  .tag-block {
    line-height: 1.2;
    display: flex;
    justify-content: flex-start;

    .name {
      width: 80px;
      flex-shrink: 0;
      height: 32px;
      line-height: 20px;
    }

    .tag {
      margin-right: 12px;
      margin-bottom: 12px;
    }
  }
  .desc {
    height: 20px;
  }
}
.flex {
  width: 324px;
  display: flex;
  // justify-content: space-between;
  align-items: center;
  & div:nth-child(1) {
    width: 140px;
  }
}
.codemirror {
  line-height: 20px;
  border: 1px solid #f1eded;
}
</style>
